/**
 * Create reducers for storing arbitrary settings.
 *
 * @param {String} type  Action type
 * @param {Object} initialState
 * @return {Function} reducer
 */

export default (TYPE, initialState = {}) => (state = initialState, { type, payload }) => {
  if (type === TYPE) {
    return {
      ...state,
      ...payload
    }
  }

  return state
}



// WEBPACK FOOTER //
// ./reducers/utils/create-settings-reducer.js